import { createFileRoute, Outlet } from '@tanstack/react-router';
import { settingsNavFor } from '../../../../../lib/staff-settings-nav';
import { useSession } from '../../../../../lib/session';
import { SettingsNav } from '../../../../../components/settings/settings-nav';

export const Route = createFileRoute('/subdomain/admin/_staff/settings')({
  staticData: { wide: true },
  component: StaffSettingsLayout,
});

function StaffSettingsLayout() {
  const { data: session } = useSession();
  return (
    <div className="flex flex-col gap-(--mbm-space-6)">
      <header className="flex flex-col gap-(--mbm-space-1)">
        <h1 className="text-heading-page text-text-strong">Settings</h1>
        <p className="text-body-compact text-text-secondary">
          {session?.user.role === 'admin'
            ? 'Your account, and how MyBusinessMate runs for the whole team.'
            : 'Your account settings.'}
        </p>
      </header>
      <div className="flex flex-col gap-(--mbm-space-6) lg:flex-row lg:gap-(--mbm-space-7)">
        <SettingsNav groups={settingsNavFor(session?.user.role)} />
        <div className="flex min-w-0 flex-1 flex-col gap-(--mbm-space-5)">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
